$(function () {

    $('.training_attendance_switch').on('change', function (e) {
        var state = $(this).prop('checked');
        if (state) {
            state = 1;
        } else {
            state = 0;
        }
        var url = $(this).data('url') + '&state=' + state;
        console.log(url);
        $.ajax({
            type: 'GET', url: url, async: false, dataType: 'json',
            success: function (data) {
                if (data.status == 'success') {
                    console.log(data);
                } else {
                    bootbox.alert('Chyba při ukládání změny');
                }
            },
            error: function (data) { // if error occured
                bootbox.alert('Chyba při provádění operace');
            }
        });
    });

    $(document).on('click', '#setAllChecked', function () {
        bootbox.confirm({
            title: 'Potvrzení',
            backdrop: true,
            message: 'Označit všechny pracovníky jako přítomné na školení?',
            buttons: {
                confirm: { label: 'Ano', className: 'btn-success' },
                cancel: { label: 'Ne', className: 'btn-danger' }
            },
            callback: function (result) {
                if (result) {
                    $('.training_attendance_switch').each(function () {
                        var state = $(this).prop('checked');
                        if (!state) {
                            $(this).trigger('click');
                        }
                    });
                }
            }
        });
    });

    const ratingInit = () => {
        const { getData, getItemFromStore } = window.phoenix.utils;
        const raters = document.querySelectorAll('[data-rater]');

        raters.forEach(rater => {
            const options = {
                reverse: getItemFromStore('phoenixIsRTL'),
                starSize: 32,
                step: 1,
                max: 4,
                element: rater,
                rateCallback(rating, done) {
                    this.setRating(rating);
                    console.log(rater.getAttribute('data-value_input'));
                    $('#' + rater.getAttribute('data-value_input')).val(rating);
                    done();
                },
                ...getData(rater, 'rater')
            };

            return window.raterJs(options);
        });
    };

    $(document).ready(function () {
        ratingInit();
    });

    $(document).on('click', '.form-evaluation-preview', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var form_uuid = $(this).data('form_uuid');
        $.ajax({
            type: 'GET', url: url, async: false, dataType: 'json',
            success: function (data) {
                if (data.status == 'success') {
                    console.log(data);
                    $('#evaluationFormPreviewModalContent').html(data.data.content);
                    $('#evaluationFormPreviewModal').modal('show');
                    $('#training-evaluation-pdf-button').attr('href', $('#training-evaluation-pdf-button').data('url') + form_uuid);
                } else {
                    bootbox.alert('Chyba při ukládání změny');
                }
            },
            error: function (data) { // if error occured
                bootbox.alert('Chyba při provádění operace');
            }
        });
    });

    $(document).on('click', '#training-evaluation-pdf-button', function (e) {
        document.location = $(this).attr('href');
    });

    $(document).on('click', '#training_missing_filter', function (e) {
        e.preventDefault();
        document.location = $(this).attr('href') + $('#filter_target').val();
    });

    $(document).on('click', '.show-workers-to-train', function (e) {
        e.preventDefault();
        var url = $(this).data('url');
        $.ajax({
            type: 'GET', url: url, async: false, dataType: 'json',
            success: function (data) {
                if (data.status == 'success') {
                    console.log(data);
                    $('#workersToTrainModalBody').html(data.data.content);
                    $('#training-title').val(data.data.training_name);
                    $('#competence-id').val(data.data.competence_id);
                    $(".duallistbox").bootstrapDualListbox({
                        filterTextClear: 'Zobrazit vše',
                        filterPlaceHolder: 'Filtrovat',
                        moveSelectedLabel: 'Přesunout vybrané',
                        moveAllLabel: 'Přesunout vše',
                        removeSelectedLabel: 'Odebrat vybrané',
                        removeAllLabel: 'Odebrat vše',
                        infoText: 'Zobrazeno {0} položek',
                        infoTextFiltered: '<span class="label label-warning">Filtrováno</span> {0} z {1}',
                        infoTextEmpty: 'Prázdný seznam',
                        selectedListLabel: 'Lidé přiřazení ke školení',
                        nonSelectedListLabel: 'Měli by absolvovat školení',
                        selectorMinimalHeight: 300
                    });
                    $('#workersToTrainModal').modal('show');
                } else {
                    bootbox.alert('Chyba při ukládání změny');
                }
            },
            error: function (data) { // if error occured
                bootbox.alert('Chyba při provádění operace');
            }
        });
    });

});